import { configReducer } from "./components/screens/reducers/configReducer";

const rootReducer = {
  config: configReducer,
};

export default rootReducer;
